<template>
  <div class="content">
    <NavbarShowcase />
    <v-main>
      <v-container fluid>
        <v-card>
          <v-card-title>
            Registro de Asistencia {{ session.route }}
          </v-card-title>
          <v-card-text>
            <div>
              <div class="text-overline font-weight-light">Fecha de la sesión</div>
              <div>{{ filter.formatDate(session.date,1) }}</div>
            </div>
            <div>
              <div class="text-overline font-weight-light">Grupo</div>
              <div>Grupo {{ session.group }}</div>
            </div>
            <div>
              <div class="text-overline font-weight-light">Registro</div>
              <div class="mb-3">Por favor ingresa tu número de documento, debes haber realizado tu inscripción previamente para poder registrar asistencia:</div>
              <v-text-field v-model="object.document" variant="outlined" density="compact" 
                placeholder="Número de documento (Este campo solo acepta números)" 
                onkeypress="return event.charCode>=48 && event.charCode<=57"
                :error-messages="v$.document.$errors.map(e => e.$message)"/>
              <div class="text-right">
                <v-btn color="primary" variant="flat" :loading="loading" text="Registrar mi asistencia" @click="register()"/>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>

    <!-- success -->
    <v-dialog v-model="success.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112" />
        <h2 class="text-h5 mb-6">Asistencia Registrada</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ success.text }}
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="success" variant="flat" text="Aceptar" @click="success.state = false" v-if="session.survey == 'N'"/>
        </div>        
      </v-sheet>
    </v-dialog>

    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ error.text }}
        </p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="error" variant="flat" text="Aceptar" @click="error.state = false"/>
      </div>
      </v-sheet>
    </v-dialog>

    <!-- failed -->
    <v-dialog v-model="failed" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-calendar-remove" size="112" />
        <h2 class="text-h5 mb-3">Parece que ha ocurrido un error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          No se ha podido completar el proceso, por favor contacta a soporte o comunícate con tu enlace de United Way Colombia.
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="error" variant="plain" prepend-icon="mdi-open-in-new" text="www.unitedwaycolombia.org" @click="openlink('https://unitedwaycolombia.org')"/>
        </div>
      </v-sheet>
    </v-dialog>

    <!-- closed -->
    <v-dialog v-model="closed" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-calendar-remove" size="112" />
        <h2 class="text-h5 mb-3">Registro de Asistencia</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          La sesión no existe o ya se encuentra finalizada y no admite más registros.
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="error" variant="plain" prepend-icon="mdi-open-in-new" text="www.unitedwaycolombia.org" @click="openlink('https://unitedwaycolombia.org')"/>
        </div>
      </v-sheet>
    </v-dialog>

    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>
  </div>
</template>
<script setup>
  import NavbarShowcase from '../components/navbar/NavbarShowcase';
  import axios from 'axios';
  import Params from '@/models/params';
  import Session from '@/models/session';
  import Filters from '@/models/filters';
  import { ref, reactive, computed, onMounted } from "vue";
  import { useRoute, useRouter } from 'vue-router';
  import { useVuelidate } from '@vuelidate/core';
  import { required, numeric, minLength, maxLength, helpers } from '@vuelidate/validators';

  const route = useRoute();
  const router = useRouter();

  const object = reactive({
    document: null
  });

  const success = reactive({
    state: false,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const params = ref(new Params)
  const session = ref(new Session)
  const filter = ref(new Filters)

  const process = ref(true);
  const loading = ref(false);
  const failed = ref(false);
  const closed = ref(false);
  session.value.code = route.params.session;

  const rules = computed(() => {
    return {
      document: {
        required: helpers.withMessage('Campo requerido.', required), 
        numeric: helpers.withMessage('Solo números.', numeric), 
        minLength: helpers.withMessage('Mínimo 6 números.', minLength(5)), 
        maxLength: helpers.withMessage('Máximo 15 números.', maxLength(15)), 
      }
    }
  });

  const v$ = useVuelidate(rules, object);

  async function load(){
    const frm = new FormData;
    frm.append("action","sesion");
    frm.append("sesion",session.value.code);
    const result = await eject(frm);
    process.value = false;
    if(result.state){
      session.value.setDataAsisstance(result.data[0]);
    }else{
      closed.value = true;
    }
  }

  async function register(){
    if(!await v$.value.$validate()){
      return;
    }
    loading.value = true;
    const f = new FormData;
    f.append("action", "asistencia");
    f.append("document",object.document);
    f.append("session",session.value.code);
    const result = await eject(f);
    loading.value = false;
    if(result.state){
      switch (result.data[0].response) {
        case 0:
          error.text = 'No te encuentras matrículado aún, comunícate con '+result.data[0].correo_principal;
          error.state = true;
          break;
        case 1:
          success.text = 'Tu asistencia a esta sesión ya se encuentra registrada no es necesario volver a registrar una nueva asistencia.';
          success.state = true;
          break;
        case 2:
          survey();
          break;
      }
    }else{
      failed.value = true;
    }
  }

  async function survey(){
    if(session.value.survey === 'S'){
      success.text = 'Serás redirigido a responder una encuesta de satisfacción. Tu opinión es muy importante para mejorar.';
      success.state = true;
      setTimeout(() => {
        surverysatisfaction();
      }, 1500);
    }else if(session.value.survey === 'T'){
      success.text = 'Muchas gracias por tu asistencia, el registro ha sido exitoso. Nos gustaría saber cómo te sentiste durante esta sesión, diligencia en un clic lo que representó para ti.';
      success.state = true;
      setTimeout(() => {
        surveythermometer();
      }, 2000);
    }else{
      success.text = 'Asistencia registrada exitosamente!';
      success.state = true;
    }
  }

  function surverysatisfaction(){
    router.push({name: 'surveysatisfaction', params: {session: session.value.code }});
  }

  function surveythermometer(){
    router.push({name: 'surveythermometer', params: {session: session.value.code }});
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'encuesta.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

  onMounted(() => {
    load();
  })

</script>